import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { useNavBack } from '@euler/app/flows/task/pages/inspection/site-inspection/BackButton';
import { Center } from '@euler/components/Center';
import { FC, memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Path, Svg } from 'react-native-svg';

type Props = {
  style?: StyleProp<ViewStyle>;
  iconSize?: number;
  iconColor?: string;
  onPress?: () => void;
};

export const WiredBackButton = memo(({ onPress, ...props }: Props) => {
  const navBack = useNavBack();
  return <BackButton {...props} onPress={onPress ?? navBack} />;
});

export const BackButton = memo((props: Props) => {
  return (
    <Center.Touchable style={props.style} onPress={props.onPress}>
      <BackIconArrow size={props.iconSize} fill={props.iconColor} />
    </Center.Touchable>
  );
});

const BackIconArrow: FC<SvgIconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 28, 28);
  return (
    <Svg viewBox="0 0 1024 1024" {...svgProps}>
      <Path
        d="M224 480h640a31.146667 31.146667 0 0 1 23.04 8.96c5.973333 6.016 8.96 13.696 8.96 23.04a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96h-640a31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04 31.146667 31.146667 0 0 1 8.96-23.04 31.146667 31.146667 0 0 1 23.04-8.96z m12.970667 32l266.026666 264.96c5.973333 6.698667 9.002667 14.378667 9.002667 23.04a30.72 30.72 0 0 1-9.514667 22.485333 30.762667 30.762667 0 0 1-22.485333 9.514667 33.408 33.408 0 0 1-23.04-8.96l-288-288a33.408 33.408 0 0 1-8.96-23.04c0-8.661333 2.986667-16.341333 8.96-23.04l288-288a33.408 33.408 0 0 1 23.04-8.96c8.661333 0 16.170667 3.157333 22.485333 9.514667A30.762667 30.762667 0 0 1 512 224c0 8.661333-2.986667 16.341333-8.96 23.04L236.970667 512z"
        fill={fill}
      />
    </Svg>
  );
});
